import { createFileRoute, redirect } from '@tanstack/react-router'
import { StatusCodes } from 'http-status-codes'

export const Route = createFileRoute('/(redirects)/messages/')({
  loader: () => {
    throw redirect({ to: '/chat', statusCode: StatusCodes.MOVED_PERMANENTLY })
  },
})
